import gButton from "../g-button/g-button.vue";

const name = 'cnpjExistente'
export default {
  name,

  components: {
    'g-button': gButton
   }, 

  props: { 
    visivel: {
      type: Boolean,
      default: false
    },
    emDesenvolvimento: {
      type: Boolean,
      default: false
    },
  },

  mounted () { },

  updated () { },

  data () {
    return {
      popupjaexiste: true
     }
  },

  methods: { 
    cancelarcadastrocnpj () {
      this.$emit('cancelarcadastrocnpj')
    },
    editarcnpjexistente(){
      this.$emit('editarcnpjexistente')
    }

  },

  computed: { }, 

};